import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    number: "01",
    headline: "Sin humo. Solo resultados medibles.",
    body: "No cobramos por impresiones vacías. Nos enfocamos en tráfico real, clientes que llaman y ventas que entran. Si no se puede medir, no lo hacemos.",
  },
  {
    number: "02",
    headline: "Creatividad con intención estratégica.",
    body: "Cada diseño, cada Reel y cada publicación responde a una razón: diferenciar tu marca y convertir visitantes en clientes.",
  },
  {
    number: "03",
    headline: "Trato directo, sin intermediarios.",
    body: "Hablas directamente con quien ejecuta tu proyecto. Respuestas rápidas por WhatsApp, sin burocracia ni esperas interminables.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifiesto" className="relative bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <p className="mb-4 font-mono-sig text-xs font-bold uppercase tracking-[0.3em] text-[#1D4ED8]">
          ( 02 ) — Manifiesto Socify
        </p>
        <h2 className="mb-20 max-w-3xl font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
          Tres reglas que nunca rompemos.
        </h2>

        <div className="space-y-0">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.number}
              data-testid={`manifesto-chapter-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: EASE }}
              className="grid grid-cols-1 gap-6 border-t border-slate-200 py-14 md:grid-cols-12"
            >
              <div className="md:col-span-3">
                <span className="font-mono-sig text-6xl sm:text-7xl font-bold text-transparent" style={{ WebkitTextStroke: "1.5px #1D4ED8" }}>
                  {c.number}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">
                  {c.headline}
                </h3>
              </div>
              <div className="md:col-span-5">
                <p className="text-base leading-relaxed text-slate-600">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
